<side-panel [openPanel]="isPanelActive" (panelClosed)="onPanelClosed($event)">
  <div class="notification-panel" [ngClass]="{'active' : isPanelActive}">
    <div class="panel-content">
      <header class="panel-header">
        <div class="header-row-1">
          <i class="fas fa-solid fa-bell"></i>
          <h3 class="notification-header">{{ 'shared.notifications.notifications' | translate }}</h3>
        </div>
        <div class="header-row-2">
          <p>{{ 'shared.notifications.stayUpToDate' | translate }}
            <a href="#" class="update-settings">{{ 'shared.notifications.updateSettings' | translate }}</a>
          </p>
        </div>
        <div class="header-row-3">
          <ul class="tabs">
            <li [class.active]="selectedTabName === tab.name" class="tab" *ngFor="let tab of tabs">
              <button class="tab-link" (click)="selectTab(tab, tab.name)">{{ tab.name }}</button>
            </li>
          </ul>
        </div>
      </header>

      <section class="panel-notification-list">
        <div class="notification-list">
          <p class="no-recent-notifications" *ngIf="filteredNotifications.length <= 0">{{ 'shared.notifications.noRecentNotifications' | translate }}</p>

          <div class="notification-card" *ngFor="let notification of filteredNotifications">
            <div class="card-container">
              <div class="profile-picture">
                <img src="https://placehold.co/60x60" alt="Profile Picture">
              </div>
              <div class="notification-info">
                <div class="created">{{ notification.created | date: 'short' }}</div>
                <div class="message" (click)="viewNotification(notification)">{{ notification.message }}</div>
              </div>
              <div class="notification-status">
                <i *ngIf="notification.notificationStatus === 'Unread'" class="fas fa-solid fa-eye" (click)="updateReadStatus(notification.message, notification.notificationType, notification.userId, notification.id, notification.category, notification.reference)"></i>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</side-panel>
